import {StudioViewType} from "../constants/enums";
import {getId, getSchoolId, isAdmin, isStudent, isTeacher} from "../utils/userUtility"
import isEmpty from 'lodash/isEmpty';
import {action, computed, observable} from 'mobx'


class ShareLinkStore {
    @observable studioViewType = null

    @computed get defaultView() {
        return this.studioViewType === StudioViewType.DefaultView
    }

    @computed get studentView() {
        return this.studioViewType === StudioViewType.StudentView
    }

    @computed get marketingView() {
        return this.studioViewType === StudioViewType.MarketingView
    }

    @computed get publicView() {
        return this.studioViewType === StudioViewType.PublicView
    }

    @computed get shareView() {
        return this.studioViewType === StudioViewType.ShareView
    }

    @computed get blockView() {
        return this.studioViewType === StudioViewType.BlockView;
    }

    hasUserContent = (project, id) => {
        // if any update was done by the student
        return project.auditLog?.some(log => log.by === project.owner.id && project.owner.id !== id)
    }

    @action updateLinkStatus = (project, queryParams, activeSchool) => {
        let id = getId()

        if (queryParams.testLink === 'true') {
            id = null
        }

        // short circuit for admin
        if (isAdmin()) {
            return this.studioViewType = StudioViewType.DefaultView;
        }

        const isLibraryLesson = !project.parentOwnerId || project.parentOwnerId === project.owner.id;
        const notParentOwner = project.parentOwnerId !== id || !project.parentOwnerId
        let sameSchool = false

        if (!isEmpty(activeSchool) && id) {
            sameSchool = activeSchool.id === getSchoolId() && (activeSchool.teachers.findIndex(teacher => teacher.id === project.parentOwnerId || project.owner.id) > -1
                || activeSchool.admins.findIndex(admin => admin.id === project.parentOwnerId || project.owner.id) > -1);
        }

        // check if a timeline lesson has student content
        if (!isLibraryLesson && !!project.parentOwnerId && notParentOwner && !sameSchool) {
            if (this.hasUserContent(project, id)) {
                this.studioViewType = StudioViewType.BlockView
                return this.studioViewType
            }
        }

        if (queryParams.utm_source === "marketing" || queryParams.linkType === "marketing") {
            this.studioViewType = StudioViewType.MarketingView
            return this.studioViewType
        }

        if (queryParams.share === 'true' && !isTeacher() && (project.owner.id !== id || isStudent())) {
            this.studioViewType = StudioViewType.ShareView
            return this.studioViewType
        }

        //Student Lesson

        if (project.owner.id === id || (project.parentOwnerId === id && !!project.parentOwnerId) || sameSchool) {
            this.studioViewType = StudioViewType.DefaultView
            return this.studioViewType
        }

        const publicView = notParentOwner && project.owner.id !== id

        // Library Lesson
        if (isLibraryLesson && publicView) {
            this.studioViewType = StudioViewType.PublicView
            return this.studioViewType
        }

        // Timeline lesson
        if (!isLibraryLesson && !!project.parentOwnerId && notParentOwner) {
            this.studioViewType = StudioViewType.StudentView
            return this.studioViewType
        }

        this.studioViewType = StudioViewType.DefaultView
        return this.studioViewType
    }


    @action setDefaultView = () => {
        this.studioViewType = StudioViewType.DefaultView
    }

}

const shareLinkStore = new ShareLinkStore();
export default shareLinkStore;
